<span class="clear-button" (click)="onClickClear()" >
    <img aria-hidden="true" alt="" width="16" src="../../assets/images/icons/close-black.svg">
</span>
